import React, {useContext} from "react";
import PropTypes from 'prop-types';
import {makeStyles} from '@material-ui/core/styles';
import {IconButton, Tooltip} from "@material-ui/core";
import ClearSharpIcon from '@material-ui/icons/ClearSharp';
import AddSharpIcon from '@material-ui/icons/AddSharp';
import {uid} from 'react-uid';
import clsx from "clsx";
import ActionType from "./ActionType";
import ActionParams from "./ActionParams";
import {ScreenDesignerContextNew} from "../../../../../../../../../ContextComponents/ScreenDesignerContextNew";

const useStyles = makeStyles(() => ({
    actionHeaderButton: {
        padding: 0
    },
    actionContent: {
        position: 'relative',
        margin: '0 5px',
        boxShadow: 'rgb(136, 136, 136) 0px 1px 2px 0px',
        '& $actionHeader': {
            display: 'none',
        },
        '&:hover': {
            '& $actionHeader': {
                display: 'block',
            }
        },
        padding: 5

    },
    addBeforeArea: {
        height: 10,
        margin: '0 5px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        transition: 'all 0.2s ease',
        '& button': {
            visibility: 'hidden',
        },
        '&:hover': {
            height: '15px',
            cursor: 'pointer',
            transition: 'all 0.2s ease',
            boxShadow: 'rgba(136, 136, 136, 0.5) 0 -1px 2px 0px',
            marginTop: 5,
            '& button': {
                visibility: 'visible',
            }
        }
    },
    addAfterArea: {
        height: 10,
        margin: '0 5px',
        display: 'flex',
        alignItems: 'center',
        justifyContent: 'center',
        transition: 'all 0.2s ease',
        '& button': {
            visibility: 'hidden'
        },
        '&:hover': {
            height: '15px',
            cursor: 'pointer',
            boxShadow: 'rgb(136, 136, 136) 0px 1px 2px 0px',
            marginBottom: 5,
            '& button': {
                visibility: 'visible',
            }
        }
    },
    actionHeader: {
        position: 'absolute',
        top: 5,
        right: -5,
        width: 30,
    },
    actionContentHeader: {
        display: 'flex',
        marginBottom: 10,

    }
}));

function noop(...args) {
    console.log(args)
}

const disabledParams = [
    'executeJs', 'setStyles', 'disableAllFields',
    'readRecord', 'updateEntity', 'deleteEntity',
    'createEntity', 'refreshData', 'getListData',
    'externalLink', 'cameraScreenshot'
];

const ActionForm = (props) => {
    const {listStorage, screenValues: {otherComponents = []}, selectedComponent} = useContext(ScreenDesignerContextNew);
    const {
        schema, actions, createAction, removeAction,
        setValue, createParam, removeParam,
    } = props;
    const classes = useStyles();
    return (
        <>
            {(actions || [{}]).map((action, actionIndex) => {
                const isDisabledParams = disabledParams.includes(action.type);
                return (
                    <React.Fragment key={uid(`${action.type}_${actionIndex}`)}>
                        {actionIndex === 0 && (
                            <AddArea direction={'before'} actionIndex={actionIndex} createAction={createAction}/>
                        )}
                        <div className={classes.actionContent}>
                            <div className={classes.actionContentHeader}>
                                <ActionType
                                    schema={schema}
                                    action={action}
                                    actions={actions}
                                    setValue={setValue}
                                    path={`${actionIndex}`}
                                    listStorage={listStorage}
                                    contextMenu={otherComponents.filter(i => i.type === 'context')}
                                    entities={otherComponents.filter(i => i.type === 'entity')}
                                    selectedComponent={selectedComponent}
                                />
                                <ActionHeader
                                    remove={removeAction}
                                    actionIndex={actionIndex}
                                />
                            </div>
                            {!isDisabledParams && (
                                <div style={{padding: 5}}>
                                    <ActionParams
                                        action={action}
                                        actions={actions}
                                        setValue={setValue}
                                        path={`${actionIndex}`}
                                        actionIndex={actionIndex}
                                        createParam={createParam}
                                        removeParam={removeParam}
                                        isDisabledParams={isDisabledParams}
                                    />
                                </div>
                            )}
                        </div>
                        <AddArea direction={'after'} actionIndex={actionIndex + 1} createAction={createAction}/>
                    </React.Fragment>
                )
            })}
        </>
    )
};
export default ActionForm

ActionForm.propTypes = {
    schema: PropTypes.array,
    eventIndex: PropTypes.any, //null or number
    actions: PropTypes.array,
    createAction: PropTypes.func,
    removeAction: PropTypes.func,
    createParam: PropTypes.func,
    removeParam: PropTypes.func,
    setValue: PropTypes.func
};

ActionForm.defaultProps = {
    setValue: noop,
    createAction: noop,
    removeAction: noop,
    createParam: noop,
    removeParam: noop
};

const ActionHeader = ({remove, actionIndex}) => {
    const classes = useStyles();
    return (
        <div className={classes.actionHeader}>
            <Tooltip title={"Remove Action"}>
                <IconButton
                    tabIndex={-1}
                    className={classes.actionHeaderButton}
                    onClick={() => remove(actionIndex)}
                >
                    <ClearSharpIcon fontSize={"small"}/>
                </IconButton>
            </Tooltip>
        </div>
    )
};

const AddArea = ({createAction, actionIndex, direction}) => {
    const classes = useStyles();
    const style = clsx({
        [classes.addAfterArea]: direction === 'after',
        [classes.addBeforeArea]: direction === 'before'
    });
    return (
        <div
            className={style}
            onClick={() => createAction(actionIndex)}>
            <IconButton style={{padding: 0}} onClick={() => createAction(actionIndex)}>
                <AddSharpIcon fontSize={"small"}/>
            </IconButton>
        </div>
    )
};